import React, {useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./Header";
import Footer from "./Footer";
// import { Footer } from "rsuite";

const MainLayout = (props) => {
    return (
        <div className="mainlayout-maindiv">

            <Header />
            <div className="mainlayout-body">
                {props.children}
            </div>
           <Footer />
        </div>
    )
}

export default MainLayout